import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface SubscriptionStyles {
  loginLink: Styles
}

export const useStyles = createUseStyles<SubscriptionStyles>((theme) => {
  return {
    loginLink: {
      fontFamily: 'Roboto , sans-serif',
      fontWeight: '500',
      fontStyle: 'Medium',
      fontSize: theme.calcUnit(16),
      lineHeight: theme.calcUnit(18),
      color: '#3388FF',
      textAlign: 'center',
      marginTop: theme.calcUnit(28),
      marginBottom: theme.calcUnit(theme.spacing.s5),
    },
  }
})
